import { get, set, clear } from 'idb-keyval'
import { IS_LOCAL } from 'src/config'

export const USE_LOCAL_CACHE = IS_LOCAL && typeof window !== 'undefined' && !window.location.search.includes('no-cache')

export const localCacheKey = (name: string, parameters: any): string => {
  return JSON.stringify({
    name,
    ...parameters,
  })
}

export const localCacheGet = async (key: string) => {
  const data = await get(key)
  if (data) {
    return JSON.parse(data)
  }
  return undefined
}

export const localCacheSet = (key: string, data: any): void => {
  if (USE_LOCAL_CACHE) {
    set(key, JSON.stringify(data)).catch((e) => console.error(e))
  }
}

export const fakeImage = (width: number, height: number) => {
  return `https://via.placeholder.com/${width}x${height}`
}

export const localCacheClear = async () => {
  await clear()
}
